// complementary-products.js - delegation + observer approach
(function () {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function findCarouselForBtn(btn) {
    return btn.closest('.complementary-products-carousel-wrapper')?.querySelector('scroll-carousel');
  }

  function scrollCarousel(carousel, dir) {
    if (!carousel) return;
    try {
      carousel.scrollBy({ left: dir * carousel.clientWidth, behavior: 'smooth' });
    } catch (err) {
      const inner = carousel.querySelector('.complementary-products__product-list') || carousel.firstElementChild;
      if (inner) inner.scrollBy({ left: dir * carousel.clientWidth, behavior: 'smooth' });
    }
  }

  function updateAllButtonStates() {
    $$('.complementary-products-carousel-wrapper').forEach(wrapper => {
      const carousel = wrapper.querySelector('scroll-carousel');
      const prevBtn = wrapper.querySelector('.carousel-prev');
      const nextBtn = wrapper.querySelector('.carousel-next');
      if (!carousel || !prevBtn || !nextBtn) return;

      const scrollEnd = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const atStart = carousel.scrollLeft <= 1;
      const atEnd = carousel.scrollLeft >= scrollEnd - 1;

      prevBtn.classList.toggle('disable', atStart);
      nextBtn.classList.toggle('disable', atEnd);
    });
  }

  function watchCarouselScrolls() {
    $$('scroll-carousel').forEach(carousel => {
      if (carousel.dataset._scrollWatch === 'true') return;
      carousel.dataset._scrollWatch = 'true';
      carousel.addEventListener('scroll', () => window.requestAnimationFrame(updateAllButtonStates), { passive: true });
    });
  }

  function setupMutationObserver() {
    const root = document.querySelector('#cart-drawer') || document.body;
    if (!root) return;

    const mo = new MutationObserver(() => {
      setTimeout(() => {
        initCarousels();
      }, 200);
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  function initCarousels() {
    $$('scroll-carousel').forEach(carousel => {
      const wrapper = carousel.closest('.complementary-products-carousel-wrapper');
      if (!wrapper) return;

      const prevBtn = wrapper.querySelector('.carousel-prev');
      const nextBtn = wrapper.querySelector('.carousel-next');
      if (prevBtn) prevBtn.classList.add('disable');
      if (nextBtn) nextBtn.classList.add('disable');

      const checkOverflow = () => {
        const widthReady = carousel.scrollWidth > 0 && carousel.clientWidth > 0;
        if (widthReady && carousel.scrollWidth > carousel.clientWidth + 1) {
          updateAllButtonStates();
        } else {
          requestAnimationFrame(checkOverflow);
        }
      };

      checkOverflow();
    });

    watchCarouselScrolls();
  }

  // Handle button clicks
  document.addEventListener('click', e => {
    const prev = e.target.closest && e.target.closest('.carousel-prev');
    const next = e.target.closest && e.target.closest('.carousel-next');
    if (!prev && !next) return;
    e.preventDefault();

    const dir = prev ? -1 : 1;
    const carousel = findCarouselForBtn(prev || next);
    scrollCarousel(carousel, dir);
    setTimeout(updateAllButtonStates, 350);
  });

  // Wait for <scroll-carousel> definition and DOM readiness
  async function waitForCustomElements() {
    if ('customElements' in window && customElements.whenDefined) {
      try {
        await customElements.whenDefined('scroll-carousel');
      } catch (e) {}
    }
  }

  async function fullInit() {
    await waitForCustomElements();

    // Wait until layout is really ready
    requestAnimationFrame(() => {
      initCarousels();
      setupMutationObserver();

      // Run several times to catch slow image loads
      setTimeout(updateAllButtonStates, 300);
      setTimeout(updateAllButtonStates, 1000);
      setTimeout(updateAllButtonStates, 2000);
    });
  }

  // --- Lifecycle hooks ---
  document.addEventListener('DOMContentLoaded', fullInit);
  window.addEventListener('load', fullInit);
  window.addEventListener('pageshow', fullInit);
  ['cart:updated', 'cart:refresh', 'turbo:load', 'shopify:section:load'].forEach(evt =>
    document.addEventListener(evt, () => setTimeout(fullInit, 200))
  );

  // Force run again after 2 seconds (hard refresh guarantee)
  setTimeout(fullInit, 2000);
})();